var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5145 6.29635C1.04092 6.01221 0.426655 6.16577 0.142507 6.63935C-0.141641 7.11293 0.011924 7.72719 0.485504 8.01134L1.5145 6.29635ZM4.84615 9.46154L4.33166 10.319L5.11653 10.79L5.65489 10.0497L4.84615 9.46154ZM11.8087 1.58817C12.1336 1.14152 12.0348 0.516102 11.5882 0.191264C11.1415 -0.133574 10.5161 -0.0348243 10.1913 0.411828L11.8087 1.58817ZM0.485504 8.01134L4.33166 10.319L5.36065 8.60405L1.5145 6.29635L0.485504 8.01134ZM5.65489 10.0497L11.8087 1.58817L10.1913 0.411828L4.03742 8.87337L5.65489 10.0497Z",
    fill: "#499C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckArrow);
export default __webpack_public_path__ + "static/media/checkArrow.2843a3f4.svg";
export { ForwardRef as ReactComponent };